import { colors } from '@globals/themes/defaultTheme'
import { CalendarEvent } from '@kudos/http-client'
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import UserAvatar from '@shared/avatar/UserAvatar'
import useCelebrationsDisplayStyle from '@tenant/celebrate/useCelebrationsDisplayStyle'
import { format, parseISO } from 'date-fns'
import KudosTvCard from '../KudosTvCard'

type TvCelebrationProps = {
  celebration: CalendarEvent
}

const TvCelebration: React.FC<TvCelebrationProps> = ({ celebration }) => {
  const { memberDisplayData, celebratedOn, type, interval } = celebration
  const { celebrationGreeting } = useCelebrationsDisplayStyle(type, interval, memberDisplayData)
  return (
    <KudosTvCard
      primaryColor={colors.aquaPrimary}
      icon={<CelebrationOutlinedIcon />}
      postContent={
        <Stack height="inherit" justifyContent="center" alignItems="center">
          <UserAvatar
            size={180}
            firstName={memberDisplayData?.firstName}
            lastName={memberDisplayData?.lastName}
            media={memberDisplayData?.avatarUrls}
          />
          <Typography variant="h1">{celebrationGreeting}</Typography>
          {memberDisplayData?.jobTitle && (
            <Typography variant="caption" fontSize="2rem">
              {memberDisplayData?.jobTitle}
            </Typography>
          )}
          <Typography variant="body1" fontSize="2rem" mt={2}>
            {format(parseISO(celebratedOn), 'MMMM dd, yyyy')}
          </Typography>
        </Stack>
      }
    />
  )
}

export default TvCelebration
